import React from 'react'
import SupplyBillAgreeIco from '../../view/items/SupplyBillAgreeIco'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useState } from 'react';
import MyModal from '../../../../UI/modal/MyModal';
import AgreeNachBillItemForm from './AgreeHeaderBillItemForm';
import AgreeHeaderBillItemForm from './AgreeHeaderBillItemForm';

const AgreeHeaderButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження керівником'}
            ico={<VisibilityIcon />}
            value={supplyBillItem.isAgreeLeadership}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeHeaderBillItemForm
                    // supplyOrderId={supplyOrderId}
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeHeaderButton